/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
/**
 * 
 * @export
 * @interface AddScriptStepFieldRequest
 */
export interface AddScriptStepFieldRequest {
    /**
     * 
     * @type {number}
     * @memberof AddScriptStepFieldRequest
     */
    fieldId?: number;
    /**
     * 
     * @type {boolean}
     * @memberof AddScriptStepFieldRequest
     */
    isRequired?: boolean;
}

/**
 * Check if a given object implements the AddScriptStepFieldRequest interface.
 */
export function instanceOfAddScriptStepFieldRequest(value: object): boolean {
    return true;
}

export function AddScriptStepFieldRequestFromJSON(json: any): AddScriptStepFieldRequest {
    return AddScriptStepFieldRequestFromJSONTyped(json, false);
}

export function AddScriptStepFieldRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddScriptStepFieldRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'fieldId': json['fieldId'] == null ? undefined : json['fieldId'],
        'isRequired': json['isRequired'] == null ? undefined : json['isRequired'],
    };
}

export function AddScriptStepFieldRequestToJSON(value?: AddScriptStepFieldRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'fieldId': value['fieldId'],
        'isRequired': value['isRequired'],
    };
}

